<script setup lang="ts">
import type { IPaymentArrays } from '@/widgets/footer/model/types/footer-payment';
import UzumLogo from '@/shared/ui/Icons/UzumLogo.vue';
import PaymeLogo from '@/shared/ui/Icons/PaymeLogo.vue';
import ClickLogo from '@/shared/ui/Icons/ClickLogo.vue';
import MastercardLogo from '@/shared/ui/Icons/MastercardLogo.vue';
import VisaLogo from '@/shared/ui/Icons/VisaLogo.vue';
import HumoLogo from '@/shared/ui/Icons/HumoLogo.vue';
import UzcardLogo from '@/shared/ui/Icons/UzcardLogo.vue';

const { t } = useI18n();

const itemsList: Ref<IPaymentArrays> = computed(() => ({
  firstArray: [
    {
      id: 1,
      icon: PaymeLogo,
      mod: '_payme',
    },
    {
      id: 2,
      icon: ClickLogo,
      mod: '_click',
    },
    {
      id: 3,
      icon: UzumLogo,
      mod: '_uzum',
    },
  ],
  secondArray: [
    {
      id: 1,
      icon: MastercardLogo,
      mod: '_mastercard',
    },
    {
      id: 2,
      icon: VisaLogo,
      mod: '_visa',
    },
    {
      id: 3,
      icon: HumoLogo,
      mod: '_humo',
    },
    {
      id: 4,
      icon: UzcardLogo,
      mod: '_uzcard',
    },
  ],
}));
</script>

<template>
  <div class="footer-payment-partners">
    <div class="footer-payment-partners__title">
      {{ t('paymentPartners') }}
    </div>
    <div class="footer-payment-partners__content">
      <ul class="footer-payment-partners__list">
        <li
          v-for="item in itemsList.firstArray"
          :key="item.id"
          class="footer-payment-partners__item"
        >
          <component
            :is="item.icon"
            :class="`footer-payment-partners__icon ${item.mod}`"
          />
        </li>
      </ul>
      <ul class="footer-payment-partners__list">
        <li
          v-for="item in itemsList.secondArray"
          :key="item.id"
          class="footer-payment-partners__item"
        >
          <component
            :is="item.icon"
            :class="`footer-payment-partners__icon ${item.mod}`"
          />
        </li>
      </ul>
    </div>
  </div>
</template>

<style lang="less">
.footer-payment-partners {
  .flex-column(@size-x5);

  &__title {
    font-size: 15px;
    font-weight: 400;
    line-height: 100%;
    color: @color-oxford-blue;
  }

  &__content {
    .flex-column(@size-x5);
  }

  &__list {
    display: flex;
    align-items: center;
    gap: @size-x6;
  }

  &__icon {
    &._payme {
      width: 68px;
      height: 22px;
    }

    &._click {
      width: 72px;
      height: 18px;
    }

    &._uzum {
      width: 65px;
      height: 34px;
    }

    &._visa,
    &._mastercard,
    &._humo,
    &._uzcard {
      width: 46px;
      height: @size-x7;
    }
  }

  @media @1024 {
    gap: @size-x3;

    &__content {
      gap: @size-x3;
    }

    &__list {
      gap: @size-x4;
    }

    &__icon {
      &._payme {
        width: 56px;
        height: @size-x5;
      }

      &._click {
        width: 64px;
        height: @size-x5;
      }

      &._uzum {
        width: 62px;
        height: @size-x8;
      }

      &._visa,
      &._mastercard,
      &._humo,
      &._uzcard {
        width: @size-x10;
        height: @size-x6;
      }
    }
  }
}
</style>
